var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalonNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_176",
    "data-name": "Rect\\xE1ngulo 176",
    width: 40,
    height: 40,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3322",
    "data-name": "Trazado 3322",
    d: "M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3323",
    "data-name": "Trazado 3323",
    d: "M22.929,5.723,22.21,4.27A18.613,18.613,0,0,0,9.644,9.808l.309,1.229-1.287-.16a18.593,18.593,0,0,0-4.4,11.334l1.23.718-1.23.718a18.591,18.591,0,0,0,4.4,11.334l1.4-.132-.424,1.2a18.614,18.614,0,0,0,12.566,5.538l.718-1.134,3.887-16.5Z",
    transform: "translate(-2.929 -2.929)",
    fill: "#e84671"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3324",
    "data-name": "Trazado 3324",
    d: "M82.359,22.211a18.593,18.593,0,0,0-4.4-11.334l-1.525.48.548-1.549A18.613,18.613,0,0,0,64.417,4.27L63.7,5.723V40.455l.718,1.134a18.613,18.613,0,0,0,12.566-5.538l-.756-1.727,1.734.657a18.593,18.593,0,0,0,4.4-11.334l-1.326-.718Z",
    transform: "translate(-43.699 -2.929)",
    fill: "#ad1f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3325",
    "data-name": "Trazado 3325",
    d: "M92.081,47.081a14.595,14.595,0,0,1,0-24.106q-.468-.553-.977-1.07a16.029,16.029,0,0,0,0,26.245q.509-.515.977-1.069",
    transform: "translate(-57.818 -15.027)",
    fill: "#ebf3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3326",
    "data-name": "Trazado 3326",
    d: "M19.25,21.905q-.509.515-.977,1.069a14.6,14.6,0,0,1,0,24.106q.468.553.977,1.069a16.03,16.03,0,0,0,0-26.245",
    transform: "translate(-12.536 -15.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3327",
    "data-name": "Trazado 3327",
    d: "M62.13,4.222c-.241,0-.48.006-.718.015V41.556c.239.009.478.015.718.015l.359-.582L62.7,22.9,62.49,4.671Z",
    transform: "translate(-42.13 -2.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3328",
    "data-name": "Trazado 3328",
    d: "M22.9,61.413H4.237c-.009.238-.015.478-.015.718s.006.48.015.718H22.9Z",
    transform: "translate(-2.896 -42.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3329",
    "data-name": "Trazado 3329",
    d: "M63.7,61.413v1.436H82.36c.009-.238.015-.478.015-.718s-.006-.48-.015-.718Z",
    transform: "translate(-43.7 -42.131)",
    fill: "#ebf3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3330",
    "data-name": "Trazado 3330",
    d: "M64.418,41.556V4.237c-.238-.009-.478-.015-.718-.015V41.571C63.941,41.571,64.18,41.565,64.418,41.556Z",
    transform: "translate(-43.7 -2.896)",
    fill: "#ebf3ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonNav);
export default __webpack_public_path__ + "static/media/balonNav.db63900fce484514a9307a1f3a58b412.svg";
export { ForwardRef as ReactComponent };